/**
 * Webhook utility for sending order data to external services
 */

/**
 * Send order data to a webhook URL
 * @param {string} webhookUrl - The URL to send the webhook to
 * @param {object} orderData - The order data to send
 * @param {object} options - Additional options for the webhook
 * @returns {Promise} - The response from the webhook
 */
export const sendWebhook = async (webhookUrl, orderData, options = {}) => {
  try {
    if (!webhookUrl) {
      console.error('No webhook URL provided');
      return { success: false, error: 'No webhook URL provided' };
    }

    console.log(`Sending webhook to: ${webhookUrl}`);
    
    const response = await fetch(webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      },
      body: JSON.stringify(orderData)
    });

    if (!response.ok) {
      throw new Error(`Webhook failed with status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Webhook sent successfully:', data);
    return { success: true, data };
  } catch (error) {
    console.error('Error sending webhook:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Parse webhook URL from URL parameters
 * @returns {string|null} - The webhook URL or null if not found
 */
export const getWebhookUrlFromParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('webhook_url');
}; 